import { FileArchive, FileAudio2, FileCode, FileImage, FileSpreadsheet, FileText, FileVideo } from "lucide-react";

export function FileIcon(props: { fileName: string }) {
  const { fileName } = props;

  const fileType = fileName.split('.').pop();

  switch (fileType) {
    case 'pdf':
      return <FileText color="var(--red-700)" />;
    case 'docx':
      return <FileText color="var(--blue-600)" />;
    case 'xlsx':
      return <FileSpreadsheet color="var(--green-600)" />;
    case 'jpg':
      return <FileImage color="var(--blue-400)" />;
    case 'mov':
      return <FileVideo color="var(--yellow-600)" />;
    case 'json':
      return <FileCode color="var(--green-600)" />;
    case 'mp4':  
      return <FileAudio2 color="var(--yellow-600)" />;
    case 'zip':
      return <FileArchive color="var(--neutral-600)" />;
    default:
      return <FileText color="var(--blue-600)" />;
  }
}
